// Regalo automático escalonado: con 2 lámparas solares en el carrito se
// agrega 1 lámpara de pared gratis (vía descuento automático de Shopify) y
// con 3 o más se agregan 2; si el cliente baja, se ajusta o se quita. Solo toca las líneas que él mismo agregó
// (propiedad oculta _regalo), nunca una compra normal de ese producto.
(function () {
  var cfg = window.tzRegalo;
  if (!cfg) return;
  var sincronizando = false;

  function esLineaDeRegalo(item) {
    // Cualquier línea agregada automáticamente por un script de regalo
    // (esta u otra) no debe contar como "lámpara comprada" — si no, un
    // regalo puede disparar a otro regalo en cadena.
    return !!(item.properties && (item.properties._regalo || item.properties._regalo_pack3));
  }

  function contarSolares(cart) {
    return cart.items.reduce(function (total, item) {
      var esSolar = cfg.solarIds.indexOf(item.product_id) !== -1;
      return total + (esSolar && item.variant_id !== cfg.variantId && !esLineaDeRegalo(item) ? item.quantity : 0);
    }, 0);
  }

  function pintarCarrito(secciones) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && secciones && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections: secciones });
    }
  }

  function pedir(url, cuerpo) {
    cuerpo.sections = 'cart-drawer,cart-icon-bubble';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  function sincronizar(alFinalRecargar) {
    if (sincronizando) return;
    sincronizando = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var solares = contarSolares(cart);
        var deseada = solares >= 3 ? 2 : (solares >= 2 ? 1 : 0);
        var lineaRegalo = null;
        cart.items.forEach(function (item) {
          if (item.variant_id === cfg.variantId && item.properties && item.properties._regalo) lineaRegalo = item;
        });
        if (deseada > 0 && !lineaRegalo) {
          return pedir('/cart/add.js', {
            items: [{ id: cfg.variantId, quantity: deseada, properties: { _regalo: 'true' } }]
          }).then(function (res) { res && (alFinalRecargar ? location.reload() : pintarCarrito(res.sections)); });
        }
        if (lineaRegalo && lineaRegalo.quantity !== deseada) {
          return pedir('/cart/change.js', { id: lineaRegalo.key, quantity: deseada })
            .then(function (res) { res && (alFinalRecargar ? location.reload() : pintarCarrito(res.sections)); });
        }
      })
      .catch(function () {})
      .then(function () { sincronizando = false; });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { sincronizar(false); });
  }
  if (location.pathname === '/cart') sincronizar(true);
})();
